import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
  STREVDA_SLOTS,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  generateAdvertIdFromRadarCreative,
  generateAdvertIdFromStrevdaSlot,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/generateAdvertId';
import { isAdvertValid } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAdvertValid';
import { isResponseContainFlightsBody } from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import { isRadarFlightsResponseError } from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/radarFlightsResponse';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { CurrentAdvertIdsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/currentAdvertIds';

export const INITIAL_STATE: CurrentAdvertIdsState = [];
export default (
  state: CurrentAdvertIdsState = INITIAL_STATE,
  action: Action,
): CurrentAdvertIdsState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      switch (action.payload.type) {
        case RADAR_CREATE_SESSIONS:
        case RADAR_POLL: {
          if (
            isRadarFlightsResponseError(action.payload.response) ||
            !isResponseContainFlightsBody(action.payload.response)
          ) {
            return state;
          }

          const { creatives } = action.payload.response.body.itineraries;

          return creatives
            ? Array.from(
                new Set(
                  state.concat(
                    creatives // Since some of the adverts returned are invalid we need to filter them
                      .filter(isAdvertValid)
                      .map((creative) => generateAdvertIdFromRadarCreative(creative)),
                  ),
                ),
              )
            : state;
        }

        case STREVDA_SLOTS: {
          if (action.payload.response.error) {
            return state;
          }

          const { body: slots } = action.payload.response;
          const ids = slots.map(generateAdvertIdFromStrevdaSlot);
          return Array.from(new Set(state.concat(ids)));
        }

        default:
          return state;
      }
    }
    case SEARCH_PARAMS_CHANGED:
      return INITIAL_STATE;

    default:
      return state;
  }
};
export const getAll = (state: CurrentAdvertIdsState): CurrentAdvertIdsState => state;
